"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TextArea = require("./TextArea.style");
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TextArea = function TextArea(_ref) {
  var defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    id = _ref.id,
    invalid = _ref.invalid,
    name = _ref.name,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    required = _ref.required,
    size = _ref.size,
    value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_TextArea.StyledTextArea, {
    "data-key": "max-text-area",
    defaultValue: defaultValue,
    disabled: disabled,
    id: id,
    invalid: invalid,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    required: required,
    rows: size && _constants.SIZE_TO_ROWS[size],
    value: value
  });
};
TextArea.defaultProps = {
  disabled: false,
  id: null,
  invalid: false,
  placeholder: null,
  required: false,
  size: 'md'
};
var _default = TextArea;
exports.default = _default;